import { ICheckinReasonClassTypeCount } from 'libs/domain';
import { class_types_pb } from 'libs/generated-grpc-ts';

export const toProto = (typeCount: ICheckinReasonClassTypeCount): class_types_pb.CheckinReasonTypeCount => {
  const msg = new class_types_pb.CheckinReasonTypeCount();

  if (typeCount.id) msg.setId(typeCount.id);
  if (typeCount.name) msg.setName(typeCount.name);
  if (typeCount.icon) msg.setIcon(typeCount.icon);
  if (typeCount.color) msg.setColor(typeCount.color);
  if (typeCount.active) msg.setActive(typeCount.active);
  if (typeCount.priority) msg.setPriority(typeCount.priority);
  if (typeCount.count) msg.setCount(typeCount.count);
  if (typeCount.enableStudentPhoto) msg.setEnableStudentPhoto(typeCount.enableStudentPhoto);

  return msg;
};

export const fromProto = (msg: class_types_pb.CheckinReasonTypeCount): ICheckinReasonClassTypeCount => {
  const typeCounts: ICheckinReasonClassTypeCount = {
    count: msg.getCount(),
    id: msg.getId(),
    name: msg.getName(),
    active: msg.getActive(),
    icon: msg.getIcon(),
    color: msg.getColor(),
    priority: msg.getPriority(),
    enableStudentPhoto: msg.getEnableStudentPhoto(),
  };

  return typeCounts;
};
